import React, { useContext } from "react";
import Cookies from "js-cookie";
import { userContext } from "../Context/UserContext";

export const authAccReducer = (state, action) => {
    switch (action.type) {
        case "LOGIN":
            Cookies.set("access", action.accToken);
            return true;

        case "LOGOUT":
            Cookies.remove("access");
            return false;

        default:
            return false;
    }
};
